export const replaceableColors = {
  primary: '#241446',
  secondary: '#A259FF',
  third: '#FF6B6B'
}

export const config = {
  variant: 'mavis',
  borderRadius: 'round',
  topicNavigation: true,
  palette: {
    primary: '#1E3A5F',
    secondary: '#EE6C4D',
    accent: '#065F46'
  },
  colors: {
    primary: '#241446',
    secondary: '#241446',
    overlay: '#303940',
    highlight1: '#FF6B6B',
    highlight2: '#D3D5D7',
    link: '#A259FF',
    background: '#FFFFFF',
    title: '#A259FF',
    paragraph: '#050303',
    gradient: {
      DEFAULT: 'linear-gradient(90deg, #303940 0%, #656D73 100%)'
    }
  },
  header: {
    showLogo: true,
    bg: 'linear-gradient(90deg, #241446 0%, #241446 35%, #A259FF 100%)',
    url: ''
  },
  footer: {
    show: true,
    showLogo: true,
    text: ''
  },
  cover: {
    coverStyle: 'gradient',
    tagLabel: 'Trilha de Aprendizagem',
    badgeLabel: '',
    progressLabel: 'Progresso',
    gradientFrom: '#1E3A5F',
    gradientTo: '#EE6C4D',
    gradientTextColor: '#FFFFFF',
    badgeBg: 'rgba(238, 108, 77, 0.19)',
    badgeColor: '#FFFFFF',
    badgeIconColor: '#EE6C4D',
    showMenu: true,
    logoUrl:
      'https://storage-realize.s3.amazonaws.com/sprint/2d02a4e380eab219ba83817c4962d759.png'
  },
  fonts: {
    primary: 'Poppins',
    secondary: 'Inter'
  },
  blockSpace: '0px'
}

export const resources = [
  {
    id: 1,
    default: true,
    name: 'Bloco de Conteúdo',
    slug: 'D-BLOCO-DE-CONTEUDO',
    group_id: 0,
    theme: {
      showHeading: true,
      showOverline: true,
      showTitle: true,
      showImage: true,
      $bgColor: 'transparent',
      overlineColor: ' #A259FF',
      titleColor: '#241446',
      paragraphColor: '#241446',
      $bgUrl: ''
    }
  },
  {
    id: 2,
    default: true,
    name: 'Caixa de texto',
    slug: 'D-CAIXA-DE-TEXTO',
    group_id: 2,
    theme: {
      showIcon: false,
      icon: '',
      showOverline: true,
      showTitle: true,
      showImage: true,
      $icon: null,
      $bgColor: 'transparent',
      $bgUrl: ''
    }
  },
  {
    id: 3,
    default: true,
    name: 'Imagem',
    slug: 'I-IMAGEM',
    group_id: 1,
    theme: {
      showOverline: true,
      showTitle: true,
      showCaption: true,
      overlineColor: '#241446',
      image_letter_size: '10px',
      $bgColor: 'transparent',
      titleColor: '#fff'
    }
  },
  {
    id: 4,
    default: true,
    name: 'Aba',
    slug: 'I-ABAS',
    group_id: 3,
    theme: {
      showTabTitle: true,
      showImageTabs: true,
      overlineColor: '#241446',
      titleColor: '#241446',
      $bgUrl: '',
      $bgColor: 'transparent'
    }
  },
  {
    id: 5,
    default: true,
    name: 'Sanfona',
    slug: 'I-ZSANFONA',
    group_id: 3,
    theme: {
      showOverline: true,
      showTitle: true,
      overlineColor: '#241446',
      titleColor: '#241446',
      paragraphColor: '#252525',
      $bgColor: 'transparent',
      $bgUrl: ''
    }
  },
  {
    id: 6,
    default: true,
    name: 'Linha do tempo',
    slug: 'IU-LINHADOTEMPO',
    group_id: 3,
    theme: {
      showOverline: true,
      showTitle: true,
      showOverlineEvent: true,
      showTitleEvent: true,
      overlineColor: '#241446',
      titleColor: '#241446',
      $bgColor: 'transparent'
    }
  },
  {
    id: 7,
    default: true,
    name: 'Questão de Múltipla Escolha',
    slug: 'IU-MULTIPLE-CHOICE',
    group_id: 3,
    theme: {
      showOverline: true,
      showTitle: true,
      showImage: true,
      overlineColor: '#241446',
      titleColor: '#241446'
    }
  },
  {
    id: 8,
    default: true,
    name: 'Incorporar',
    slug: 'I-INCORPORAR',
    group_id: 3,
    theme: {
      showOverline: true,
      showTitle: true,
      $bgColor: 'transparent',
      overlineColor: '#fff',
      titleColor: '#fff',
      $bgUrl: ''
    }
  },
  {
    id: 9,
    default: true,
    name: 'Incorporar - IFRAME',
    slug: 'I-INCORPORAR-IFRAME',
    group_id: 3,
    theme: {
      showOverline: true,
      showTitle: true,
      overlineColor: '#241446',
      titleColor: '#241446'
    }
  },
  {
    id: 10,
    default: true,
    name: 'Botões Interativos',
    slug: 'I-BUTTONS',
    group_id: 3,
    theme: {
      showOverline: true,
      showTitle: true,
      titleColor: '#241446',
      paragraphColor: '#252525',
      $buttonColor: '#241446',
      $buttonTextColor: '#fff',
      $bgColor: 'transparent'
    }
  },
  {
    id: 11,
    default: true,
    name: 'Hotspot',
    slug: 'I-HOTSPOT',
    group_id: 3,
    theme: {
      overlineColor: '#241446',
      titleColor: '#A259FF',
      hotspotColor: '#A259FF',
      hotspotTextColor: '#1B262D',
      $bgColor: 'transparent',
      $bgUrl: '',
      hotspotActiveColor: '#FF6B6B'
    }
  },
  {
    id: 12,
    name: 'Verdadeiro ou Falso',
    slug: 'I-TRUE-OR-FALSE',
    group_id: 3,
    theme: {
      showOverline: true,
      showTitle: true,
      showImage: true,
      $bgColor: 'transparent',
      titleColor: '#A259FF',
      descriptionColor: '#241446'
    }
  },
  {
    id: 13,
    default: true,
    name: 'Galeria Multimídia',
    slug: 'I-GALLERY',
    group_id: 3,
    theme: {
      showOverline: true,
      showTitle: true,
      $bgColor: 'transparent',
      $bgUrl: '',
      overlineColor: '#241446',
      titleColor: '#241446',
      captionColor: '#252525',
      $arrowColor: '#fff',
      $arrowBgColor: '#A259FF'
    }
  },
  {
    id: 14,
    default: true,
    name: 'Flipcard',
    slug: 'I-FLIPCARD',
    group_id: 3,
    theme: {
      showOverline: true,
      showTitle: true,
      cardBackgroundColor: '#fff',
      cardBorderRadius: '8px',
      cardShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      flipDuration: '0.6s',
      frontSideBackgroundColor: '#F8F9FA',
      backSideBackgroundColor: '#E9ECEF',
      allowInvertSides: true,
      $bgColor: 'transparent',
      textColor: '#252525'
    }
  },
  {
    id: 15,
    default: true,
    name: 'Reordenar itens',
    slug: 'I-ORDERING',
    group_id: 3,
    theme: {
      showTitle: true,
      showDescription: true,
      showInstructions: true,
      showItems: true,
      titleColor: '#241446',
      descriptionColor: '#241446',
      cardBgColor: 'transparent',
      cardTextColor: '#252525',
      buttonTextColor: '#fff',
      buttonBgColor: '#A259FF'
    }
  },
  {
    id: 16,
    default: true,
    name: 'Preencher Lacunas',
    slug: 'I-FILL-BLANK',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      $bgUrl: '',
      titleColor: '#241446',
      descriptionColor: '#241446',
      textColor: '#374151',
      blankColor: '#3B82F6',
      blankBgColor: '#EBF4FF',
      tipColor: '#059669',
      tipBgColor: '#ECFDF5',
      showImage: true,
      showTip: true,
      showTitle: true,
      showDescription: true
    }
  },
  {
    id: 17,
    default: true,
    name: 'Relacionar colunas',
    slug: 'IU-RELATE-COLUMNS',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      $bgUrl: ''
    }
  },
  {
    id: 18,
    default: true,
    name: 'Key Points',
    slug: 'I-KEY-POINTS',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      cardBg: '#FAF9F4',
      borderColor: '#D5D1C3',
      titleColor: '#1B262D',
      pointColor: '#1B262D'
    }
  },
  {
    id: 19,
    default: true,
    name: 'Cenário',
    slug: 'I-SCENARIO',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      cardBg: '#FAF9F4',
      borderColor: '#D5D1C3',
      titleColor: '#1B262D'
    }
  },
  {
    id: 20,
    default: true,
    name: 'Checklist',
    slug: 'I-CHECKLIST',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      cardBg: '#FAF9F4',
      titleColor: '#1B262D'
    }
  },
  {
    id: 21,
    default: true,
    name: 'Pergunta Provocativa IA',
    slug: 'I-AI-QUESTION',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      cardBg: '#FAF9F4',
      questionColor: '#0F2C4D'
    }
  },
  {
    id: 22,
    default: true,
    name: 'Reflexão',
    slug: 'I-REFLECTION',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      cardBg: '#FAF9F4',
      borderColor: '#D5D1C3',
      titleColor: '#1B262D'
    }
  },
  {
    id: 23,
    default: true,
    name: 'Verdadeiro ou Falso Lista',
    slug: 'I-TRUE-FALSE-LIST',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      cardBg: '#FAF9F4',
      borderColor: '#D5D1C3',
      titleColor: '#1B262D'
    }
  },
  {
    id: 24,
    default: true,
    name: 'Session Card',
    slug: 'I-SESSION-CARD',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      cardBg: '#FAF9F4',
      titleColor: '#1B262D'
    }
  },
  {
    id: 25,
    default: true,
    name: 'Module Intro Card',
    slug: 'I-MODULE-INTRO',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      cardBg: '#FAF9F4',
      titleColor: '#1B262D'
    }
  },
  {
    id: 26,
    default: true,
    name: 'Citação',
    slug: 'I-QUOTE',
    group_id: 3,
    theme: {
      $bgColor: 'transparent',
      textColor: '#1B262D',
      authorColor: '#888888',
      accentColor: '#FD314D'
    }
  }
]
